module.exports = __webpack_public_path__ + "img/nature.9974e1c.webp";